import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { Spotlight } from '@atlaskit/onboarding';

const initialState = {
  spotlight: 0,
};

class SpotlightSection extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onSpotlightNext = this.onSpotlightNext.bind(this);
    this.onSpotlightPrev = this.onSpotlightPrev.bind(this);
  }

  componentWillMount() {
    const spotlight = document.querySelector('.spotlight');
    const nodes = spotlight ? spotlight.querySelectorAll('a') : [];

    const actions = [{
      onClick: this.props.onSpotlightClose,
      text: 'x',
    }, {
      onClick: this.onSpotlightPrev,
      text: 'Prev',
    }, {
      onClick: this.onSpotlightNext,
      text: 'Skip',
    }];

    this.spotlight = [
      <Spotlight
        actions={[actions[0], actions[2]]}
        actionsBeforeElement="1 / 6"
        dialogPlacement="bottom right"
        isFlat
        heading="Do you need help?"
        key="report-promotion"
        target="report-promotion"
      >
        <p>
          This is the Help for &quot;Create report&quot; &quot;Edit report&quot;,
          &quot;Permission report&quot;, &quot;Duplicate report&quot;
          and &quot;Delete report&quot; buttons.
        </p>
      </Spotlight>,
      <Spotlight
        actions={actions}
        actionsBeforeElement="2 / 6"
        dialogPlacement="bottom center"
        heading="Create report"
        key="create-report"
        target="create-report"
        targetRadius={2}
      >
        <p>
          For creating a new report you can design your report with
          &quot;Report name&quot; you give and
          &quot;Configuration&quot; with taking datas from &quot;SQL TABLE COLUMN&quot;.
        </p>
        <p>
          Press the &quot;Continue&quot; button then you adjust you report template and
          click the &quot;ave and Create&quot; button.
        </p>
      </Spotlight>,
      <Spotlight
        actions={actions}
        actionsBeforeElement="3 / 6"
        dialogPlacement="bottom center"
        heading="Edit report"
        key="edit-report"
        targetNode={nodes[0]}
      >
        <p>
          You can edit your report with this button you can rename your
          &quot;Report name&quot; or change your &quot;Configuration&quot;.
        </p>
        <p>Then you can press the button “Continue” and save your template.</p>
      </Spotlight>,
      <Spotlight
        actions={actions}
        actionsBeforeElement="4 / 6"
        dialogPlacement="bottom center"
        heading="Report permission"
        key="report-permission"
        targetNode={nodes[1]}
      >
        <p>It Helps you to adjust the visibility of your reports.</p>
      </Spotlight>,
      <Spotlight
        actions={actions}
        actionsBeforeElement="5 / 6"
        dialogPlacement="bottom center"
        heading="Duplicate report"
        key="duplicate-report"
        targetNode={nodes[2]}
      >
        <p>You can duplicate your report in the same format as a copy.</p>
      </Spotlight>,
      <Spotlight
        actions={[actions[0], actions[1]]}
        actionsBeforeElement="6 / 6"
        dialogPlacement="bottom center"
        heading="Delete report"
        key="delete-report"
        targetNode={nodes[3]}
      >
        If you want to delete your report then you click this button.
      </Spotlight>,
    ];
  }

  onSpotlightNext() {
    this.setState({ spotlight: this.state.spotlight + 1 });
  }

  onSpotlightPrev() {
    this.setState({ spotlight: this.state.spotlight - 1 });
  }

  render() {
    return this.spotlight[this.state.spotlight];
  }
}

SpotlightSection.propTypes = {
  onSpotlightClose: PropTypes.func.isRequired,
};

export default SpotlightSection;
